module.exports = __webpack_public_path__ + "img/j_gcc.23edbef6.jpg";